import clsx from 'clsx';

// Hooks
import useUser from '@/utils/hooks/swr/useUser';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

// Lib
import { POST, STORY } from '@/lib/posts/postTypes';
import { FACEBOOK, INSTAGRAM, LINKEDIN, TIKTOK_BUSINESS } from '@/lib/socialProfile';

// Components
import Tabs from '@/components/base/Tabs';
import { MediaViewerPreview } from './components/MediaViewerPreview';
import MediaViewerComments from '@/components/composite/MediaViewer/components/MediaViewerComments';
import MediaViewerHeader from '@/components/composite/MediaViewer/components/MediaViewerHeader';
import { MediaViewerLabelsAlbums } from '@/components/composite/MediaViewer/components/MediaViewerLabelsAlbums';
import MediaViewerStats from '@/components/composite/MediaViewer/components/MediaViewerStats';

const MediaViewerContent = ({
    post,
    postType,
    socialNetworkType,
    socialNetworkId,
    socialProfile,
    isLoading,
    hasNavigation = true,
    mutateMedia = () => {
        /** */
    },
    mutateMedias = () => {
        /** */
    },
    defaultTabsIndex = 0
}) => {
    const { t } = useTranslation('commons');
    const { user } = useUser();

    return (
        <div className="flex min-h-full flex-col md:flex-row" id="media-viewer-content">
            <div
                className={clsx(
                    'w-full bg-white px-8 pb-8 pt-12 dark:bg-icoDarkMode-anthracite md:w-2/4 md:pb-20 md:pt-15',
                    {
                        'xl:pl-40 xl:pr-10': hasNavigation,
                        'md:px-12': !hasNavigation
                    }
                )}>
                <div className="w-full md:ml-auto md:max-w-[32rem]">
                    <MediaViewerHeader
                        post={post}
                        user={user}
                        isLoading={isLoading}
                        socialProfile={socialProfile}
                        className="mb-5 md:mb-9 md:mt-1"
                    />
                    <MediaViewerPreview
                        post={post}
                        postType={postType}
                        isLoading={isLoading}
                        socialProfile={socialProfile}
                    />
                    <MediaViewerLabelsAlbums
                        socialProfile={socialProfile}
                        post={post}
                        postType={postType}
                        isLoading={isLoading}
                        mutateMedia={mutateMedia}
                        mutateMedias={mutateMedias}
                    />
                </div>
            </div>
            <div
                className={clsx(
                    'relative w-full bg-icoGray-100 px-8 pb-12 pt-8 dark:bg-icoDarkMode-deepBlack md:w-2/4 md:px-5 md:pb-20 md:pt-15',
                    {
                        'xl:pl-10 xl:pr-40': hasNavigation,
                        'xl:px-12': !hasNavigation
                    }
                )}>
                <div className="w-full md:max-w-[32rem]">
                    {socialNetworkType === FACEBOOK ||
                    socialNetworkType === TIKTOK_BUSINESS ||
                    socialNetworkType === LINKEDIN ||
                    (socialNetworkType === INSTAGRAM && postType === POST) ? (
                        <Tabs
                            tabs={[
                                { label: t('media_viewer.stats'), icon: 'stats' },
                                { label: t('media_viewer.comments'), icon: 'conversations' }
                            ]}
                            defaultIndex={defaultTabsIndex}>
                            <MediaViewerStats
                                post={post}
                                socialNetworkType={socialNetworkType}
                                socialNetworkId={socialNetworkId}
                                postFormat={postType}
                                isLoading={isLoading}
                            />
                            <MediaViewerComments
                                post={post}
                                user={user}
                                socialProfile={socialProfile}
                                isLoading={isLoading}
                            />
                        </Tabs>
                    ) : (
                        <MediaViewerStats
                            post={post}
                            socialNetworkType={socialNetworkType}
                            socialNetworkId={socialNetworkId}
                            postFormat={postType}
                            isLoading={isLoading}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

MediaViewerContent.propTypes = {
    mediaId: PropTypes.string,
    post: PropTypes.object,
    postType: PropTypes.oneOf([POST, STORY]),
    socialNetworkType: PropTypes.string,
    socialNetworkId: PropTypes.number,
    isLoading: PropTypes.bool,
    hasNavigation: PropTypes.bool,
    mutateMedia: PropTypes.func,
    mutateMedias: PropTypes.func,
    defaultTabsIndex: PropTypes.number
};

export default MediaViewerContent;
